import { Fragment } from 'react';

const ClubCreditCard = ({ creditCard, activeClubMemberships }) => {
  if (activeClubMemberships) {
    const creditCardInMemberships = activeClubMemberships.filter(
      (membership) => membership.customerCreditCardId === creditCard.id
    );
    if (creditCardInMemberships.length > 0) {
      return creditCardInMemberships.map((clubMembership) => (
        <Fragment key={clubMembership.id}>
          <br />
          <em>({clubMembership.club.title} Credit Card)</em>
        </Fragment>
      ));
    }
  }
  return null;
};

export default ClubCreditCard;
